/* 🤖 this file was generated by svg-to-ts */
export const fthrCheck: {
    name: 'fthr-check';
    data: string;
} = {
    name: 'fthr-check',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="feather feather-check" viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg>`,
};
